import { ChevronRightIcon, Text } from '@cdl/heartbeat-react';
import { useSelector } from 'react-redux';
import { InfoModal } from './InfoModal';
import { leadsWithoutNoiseAnnotationSelector } from '../../wave/selectors/wave.selectors';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const MissingNoiseAnnotationsModal = ({
  isOpen,
  onClose,
  onConfirm,
}: Props) => {
  const emptyInvWavesLeads = useSelector(leadsWithoutNoiseAnnotationSelector);

  return (
    <InfoModal
      isOpen={isOpen}
      title={'⚠️ Leads without noise annotation'}
      onClose={onClose}
      closeButtonLabel='Go back'
      onConfirm={onConfirm}
      confirmButtonLabel='Continue to next ECG'
      confirmButtonRightIcon={<ChevronRightIcon />}
      withDashedBorder
    >
      <Text as='span'>
        You have not annotated any noise on leads
        <Text as='b' ml='s'>
          {emptyInvWavesLeads.join(', ')}
        </Text>
        .
      </Text>
      <Text>
        Please ensure this is intentional before moving on to the next ECG.
      </Text>
    </InfoModal>
  );
};
